<i18n>
{
    "en":{
        "ListSensorWarnings": "List Sensor Warnings"
    },
    "vi":{
        "ListSensorWarnings": "Danh sách cảnh báo"
    }
}
</i18n>

<template>
	<div
		class="list-sensor-warnings p-6 pb-4"
		v-if="$store.state.dashboardManagement.isFetchedSensorAlerts"
	>
		<div class="flex justify-between header list-sensor-warnings__header">
			<h4 class="flex-grow header__title">{{ $t("ListSensorWarnings") }}</h4>
		</div>

		<transition-group
			tag="div"
			name="slide-fade"
			class="vx-row content list-sensor-warnings__content flex flex-wrap justify-between mt-6"
		>
			<div
				:key="`${warning.id}-${warning.updated_at}`"
				v-for="warning in listWarnings"
				class="vx-col vs-xs-12 vs-sm-6 vs-lg-6"
			>
				<div class="item content__item p-3 mb-5 flex items-center">
					<div class="item__shape mr-3">
						<i :class="`nucleo ${warning.categoryIcon}`" :style="{color: warning.statusColor}"></i>
					</div>
					<div class="info item__info">
						<div class="desc info__desc text-black">
							<p v-html="warning.message"></p>
						</div>
						<div class="info__date text-gray-3">{{ warning.sensorData.updatedAt | dateTime(userDateTimeFormat) }}</div>
					</div>
				</div>
			</div>
		</transition-group>

		<div class="test-actions" v-if="isNotProduction">
			<button @click="handleRemove">Remove</button>
			<button @click="handleReset" class="ml-3">Reset</button>
			<button @click="handleChangeData" class="ml-3">ChangeSensorData</button>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			socketData: null,
			listWarnings: []
		};
	},
	computed: {
		...mapGetters({
			getParsedSensorAlerts: "dashboardManagement/getParsedSensorAlerts"
		}),
		warnings() {
			return (this.getParsedSensorAlerts || []).filter(
				alertDevice => alertDevice.categoryIcon
			);
		},
		isNotProduction() {
			return process.env.NODE_ENV !== "production";
		}
	},
	watch: {
		warnings() {
			this.listWarnings = _.orderBy(this.warnings, ['sensorData.updatedAt'], ['desc']);
		}
	},
	methods: {
		async getListWarnings() {
			try {
				this.$vs.loading();
				const queryOptions = {
					limit: 10,
					is_active: 1
				};

				await this.$store.dispatch(
					"dashboardManagement/fetchSensorAlerts",
					queryOptions
				);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		handleRemove() {
			const temp = [...this.listWarnings];
			temp.splice(Math.floor(Math.random()*temp.length), 1);
			this.listWarnings = temp;
		},
		handleReset() {
			this.listWarnings = this.warnings;
		},
		handleChangeData() {
			const randomIndexItem = Math.floor(Math.random() * this.listWarnings.length);
			this.listWarnings = this.listWarnings.map(warning => {
				if(warning.id === this.listWarnings[randomIndexItem].id) {
					warning.updated_at = Math.random();
				}
				return warning;
			});
		}
	},
	created() {
		this.getListWarnings();
	}
};
</script>

<style lang="scss" scoped>
.list-sensor-warnings {
	overflow: hidden;

	.list-sensor-warnings__content {
		.item {
			border-radius: 8px;
			border: 1px solid #e5e5e5;

			.item__shape {
				transition: var(--common-transition);

				.nucleo {
					&::before {
						font-size: 39px;
						vertical-align: -webkit-baseline-middle;
					}
				}
			}

			.info__date {
				font-size: 12px;
			}
		}
	}
}
</style>
